var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex"},[_c('p',[_vm._v(_vm._s(_vm.offer_data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }